import { render, staticRenderFns } from "./Vertiges.vue?vue&type=template&id=acb48ce8"
import script from "./Vertiges.vue?vue&type=script&lang=js"
export * from "./Vertiges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports